/* LK — barre à paliers du panier : mise à jour dynamique + cadeaux automatiques au choix.
   Config : <script id="lk-paliers-config"> (snippets/lk-cart-fs-bar.liquid, mode config_only).
   - Total compté = cart.total_price moins les lignes cadeau (property _lk_cadeau = g1|g3).
   - Règle du 03/11 (config hb) : les fins de série (tag destockage, lues dans /collections/bonnes-affaires/products.json)
     ne comptent pas pour les cadeaux ; le relais offert compte tout le panier. Même règle que la remise « 3 cadeaux »
     (collection eligibilite-cadeaux-59-hors-bonnes-affaires-interne) et que snippets/lk-paliers-seuils.liquid.
   - Palier atteint → ajoute le cadeau choisi (sinon le 1er de la collection), 1 unité.
   - Repassé sous le palier → retire le cadeau. Quantité cadeau forcée à 1.
   - « Changer » → remplace le cadeau par un autre de la collection (choix mémorisé pour la session).
   - Cadeau retiré à la main alors que le palier est atteint → choix respecté (sessionStorage).
   - Garde-fou : un cadeau qui n'est pas à 0 € après réductions est retiré (on ne facture jamais un cadeau).
   - Lignes découpées par Shopify (réduction « Achetez X, obtenez Y ») affichées en une seule ligne par le thème :
     quantité / « Retirer » sur cette ligne → mise à jour de TOUTES ses clés (data-lk-merge-keys) via /cart/update.js.
   Déclencheurs : chargement + 'cart:refresh' (intercepteur fetch de global.js). */
(function () {
  'use strict';
  if (window.__lkPaliers) return;
  window.__lkPaliers = true;

  var busy = false;
  var again = false;
  var seen = {};    // cadeau présent au dernier passage ?
  var failed = {};  // cadeau refusé (rupture / réduction absente) → ne pas réessayer en boucle
  var lastT = null; // total cadeaux au dernier rendu (animation de déblocage)
  var lastF = null; // total relais au dernier rendu
  var BX = null;    // produits fins de série : {product_id: 1}
  var CFG = null;
  var lastCart = null;

  function cfg() {
    if (CFG) return CFG;
    var js = document.getElementById('lk-paliers-config');
    if (!js) return null;
    try { CFG = JSON.parse(js.textContent); } catch (e) { CFG = null; }
    return CFG;
  }

  function money(cents) {
    var a = (cents / 100).toFixed(2);
    var f = (CFG && CFG.mf) || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return a.replace('.', ',');
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return a;
    });
  }

  function store(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  function tier(id) {
    var c = cfg();
    if (!c) return null;
    for (var i = 0; i < c.tiers.length; i++) if (c.tiers[i].id === id) return c.tiers[i];
    return null;
  }

  function chosenVariant(t, taken) {
    var pick = parseInt(store('lk_cad3_' + t.id), 10);
    if (pick && !failed[pick] && !taken[pick]) return pick;
    for (var j = 0; j < t.opts.length; j++) if (!failed[t.opts[j].v] && !taken[t.opts[j].v]) return t.opts[j].v;
    return null;
  }

  function giftLine(cart, id) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties;
      if (p && p._lk_cadeau === id) return cart.items[i];
    }
    return null;
  }

  function eligible(cart) {
    var g = 0;
    cart.items.forEach(function (it) {
      if (it.properties && it.properties._lk_cadeau) g += it.final_line_price;
    });
    return Math.max(0, cart.total_price - g);
  }

  // total compté pour les cadeaux : sans les fins de série
  function eligibleG(cart) {
    var t = eligible(cart);
    if (!BX) return t;
    cart.items.forEach(function (it) {
      if (!(it.properties && it.properties._lk_cadeau) && BX[it.product_id]) t -= it.final_line_price;
    });
    return Math.max(0, t);
  }

  // totaux pour les autres barres du thème (pages collection) : {fs: relais, g: cadeaux}
  window.lkPaliersTotaux = function (cart) { return { fs: eligible(cart), g: eligibleG(cart) }; };

  // liste des fins de série, gardée 10 min pour la session ; en cas d'échec, rien n'est exclu (le garde-fou retire un cadeau non offert)
  function loadBX(c) {
    if (!c.hb) return Promise.resolve(null);
    if (BX) return Promise.resolve(BX);
    try { var s = JSON.parse(store('lk_bx') || 'null'); if (s && s.ids && Date.now() - s.t < 600000) { BX = s.ids; return Promise.resolve(BX); } } catch (e) {}
    return fetch('/collections/' + (c.bxc || 'bonnes-affaires') + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('bx ' + r.status); return r.json(); })
      .then(function (j) {
        var ids = {};
        (j.products || []).forEach(function (p) {
          var tg = p.tags || [];
          if (typeof tg === 'string') tg = tg.split(/,\s*/);
          if (tg.indexOf('destockage') >= 0) ids[p.id] = 1;
        });
        BX = ids;
        store('lk_bx', JSON.stringify({ t: Date.now(), ids: ids }));
        return BX;
      })
      .catch(function () { return null; });
  }

  // paliers ordonnés : [{id:'g1',s},{id:'fs',s},{id:'g3',s}]
  function steps(c) {
    var out = [];
    c.tiers.forEach(function (t) { out.push({ id: t.id, s: t.s }); });
    out.push({ id: 'fs', s: c.fs });
    return out.sort(function (a, b) { return a.s - b.s; });
  }

  function message(tf, tg, c) {
    var st = steps(c);
    for (var i = 0; i < st.length; i++) {
      var t = st[i].id === 'fs' ? tf : tg;
      if (t < st[i].s) {
        var r = '<b>' + money(st[i].s - t) + '</b>';
        if (st[i].id === 'fs') return 'Plus que ' + r + ' pour le relais offert';
        return 'Plus que ' + r + ' pour tes <b>3 cadeaux offerts</b>' + (tg < tf ? ' <small>(hors bonnes affaires)</small>' : '');
      }
    }
    return '<b>Relais + 3 cadeaux offerts</b>';
  }

  // Repères à distance égale : 28 % pour le relais, 76 % pour les cadeaux.
  function fillPct(tf, tg, c) {
    if (tg >= c.max) return 100;
    if (tf >= c.fs) return 28 + (Math.max(0, tg - c.fs) * 48) / (c.max - c.fs);
    return (tf * 28) / c.fs;
  }

  function render(cart, c) {
    var tf = eligible(cart), t = eligibleG(cart);
    var st = steps(c);
    var next = null;
    for (var i = 0; i < st.length; i++) if ((st[i].id === 'fs' ? tf : t) < st[i].s) { next = st[i]; break; }
    lastCart = cart;
    document.querySelectorAll('[data-lk-pal]').forEach(function (bar) {
      bar.setAttribute('data-lk-total', tf);
      bar.setAttribute('data-lk-tg', t);
      bar.classList.toggle('is-complete', !next);
      var fill = bar.querySelector('[data-lk-fill]');
      if (fill) {
        fill.style.width = fillPct(tf, t, c) + '%';
      }
      var msg = bar.querySelector('[data-lk-msg]');
      if (msg) {
        var html = message(tf, t, c);
        if (msg.innerHTML !== html) { msg.innerHTML = html; msg.classList.remove('lk-in'); void msg.offsetWidth; msg.classList.add('lk-in'); }
      }
      bar.querySelectorAll('[data-s]').forEach(function (n) {
        var s = parseInt(n.getAttribute('data-s'), 10);
        var cur = s === c.fs ? tf : t, prev = s === c.fs ? lastF : lastT;
        var won = cur >= s;
        n.classList.toggle('is-won', won);
        n.classList.toggle('is-next', !!next && next.s === s);
        if (n.classList.contains('lk-pal__step') && prev !== null && prev < s && won) {
          n.classList.remove('lk-pop'); void n.offsetWidth; n.classList.add('lk-pop');
        }
      });
    });
    lastT = t;
    lastF = tf;
    animT = t;
    animF = tf;
    return t;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshUI() {
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) {
      if (typeof el.onCartUpdate === 'function') el.onCartUpdate();
    });
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !s || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function release() {
    // laisse passer le cart:refresh émis par nos propres appels avant de réécouter
    setTimeout(function () {
      busy = false;
      if (again) { again = false; sync(); }
    }, 200);
  }

  function sync() {
    if (busy) { again = true; return; }
    var c = cfg();
    if (!c) return;
    busy = true;
    var changed = false;

    loadBX(c).then(getCart)
      .then(function (cart) {
        var t = render(cart, c);
        var chain = Promise.resolve();
        // Cadeau d'un ancien palier resté dans un panier : il n'existe plus, on le retire.
        cart.items.forEach(function (it) {
          var id = it.properties && it.properties._lk_cadeau;
          if (id && !tier(id)) {
            chain = chain.then(function () {
              return post('/cart/change.js', { id: it.key, quantity: 0 }).then(function () { changed = true; setTimeout(refreshUI, 1500); });
            });
          }
        });
        var taken = {};
        c.tiers.forEach(function (g) {
          var l = giftLine(cart, g.id);
          if (l) taken[l.variant_id] = true;
        });
        c.tiers.forEach(function (g) {
          var line = giftLine(cart, g.id);
          var v = chosenVariant(g, taken);
          if (!line && t >= g.s && v) {
            taken[v] = true;
            chain = chain.then(function () {
              return post('/cart/add.js', { items: [{ id: v, quantity: 1, properties: { _lk_cadeau: g.id } }] })
                .then(function () { seen[g.id] = true; changed = true; })
                .catch(function () { failed[v] = true; seen[g.id] = false; });
            });
          } else if (line && t < g.s) {
            chain = chain.then(function () {
              return post('/cart/change.js', { id: line.key, quantity: 0 })
                .then(function () { seen[g.id] = false; changed = true; });
            });
          } else if (line && line.quantity > 1) {
            chain = chain.then(function () {
              return post('/cart/change.js', { id: line.key, quantity: 1 })
                .then(function () { seen[g.id] = true; changed = true; });
            });
          } else {
            seen[g.id] = !!line;
          }
        });
        return chain;
      })
      .then(getCart)
      .then(function (cart) {
        // garde-fou : un cadeau n'est jamais facturé (réduction absente, modifiée ou non cumulable)
        var chain = Promise.resolve();
        c.tiers.forEach(function (g) {
          var line = giftLine(cart, g.id);
          if (line && line.final_line_price > 0) {
            failed[line.variant_id] = true;
            changed = true;
            chain = chain.then(function () {
              return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { seen[g.id] = false; });
            });
            if (window.console) console.warn('[lk-paliers] cadeau ' + g.id + ' non offert par les réductions → retiré');
          }
        });
        if (!changed) return;
        return chain.then(getCart).then(function (cart2) { render(cart2, c); refreshUI(); });
      })
      .catch(function () {})
      .then(release);
  }

  function pick(tierId, v, btn) {
    var c = cfg();
    if (!c) return;
    if (busy) { setTimeout(function () { pick(tierId, v, btn); }, 300); return; }
    busy = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    store('lk_cad3_' + tierId, String(v));
    try { sessionStorage.removeItem('lk_cadeau_refus_' + tierId); } catch (e) {}
    getCart()
      .then(function (cart) {
        var line = giftLine(cart, tierId);
        var rm = line ? post('/cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve();
        return rm.then(function () {
          return post('/cart/add.js', { items: [{ id: v, quantity: 1, properties: { _lk_cadeau: tierId } }] });
        });
      })
      .then(function () { seen[tierId] = true; })
      .catch(function () { failed[v] = true; })
      .then(function () { refreshUI(); })
      .then(release, release);
  }

  // ----- Sensations au toucher -----
  // Vibration sur Android ; sur iPhone récent, retour haptique par l'interrupteur natif, seulement pendant un toucher.
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hapticEl = null;
  function haptic(kind) {
    if (calme) return;
    try {
      if (navigator.vibrate) { navigator.vibrate(kind === 'win' ? [12, 45, 22] : 8); return; }
      if (!hapticEl) {
        hapticEl = document.createElement('label');
        hapticEl.setAttribute('aria-hidden', 'true');
        hapticEl.style.cssText = 'position:fixed;left:-99px;top:-99px;width:1px;height:1px;opacity:0;pointer-events:none';
        var sw = document.createElement('input');
        sw.type = 'checkbox';
        sw.setAttribute('switch', '');
        sw.tabIndex = -1;
        hapticEl.appendChild(sw);
        document.body.appendChild(hapticEl);
      }
      hapticEl.click();
    } catch (err) {}
  }
  var PRESS = '.product-form__submit,.quick-add__submit,.quick-add-modal__toggle,.lk7__atc,.lkc4__atc,.lkc4-qv__add,.lk-quickadd,.lk-quick-add-btn,.lk-featured-quick-add-btn,.lkcs-card__add,.lke-card__add,.lk-ucard__a,.quantity__button,.cart__checkout-button,.lk-checkout,.lk-gr,.lk-gc,.lk-gp__ok,.lk-gp__s.is-on,[data-lk-gifts-open]';
  (function () {
    var st = document.createElement('style');
    st.textContent = PRESS + '{touch-action:manipulation;-webkit-tap-highlight-color:transparent}.lk-press{transform:scale(.955)!important;transition:transform .07s ease-out!important}.lk-press-out{transition:transform .26s cubic-bezier(.3,1.7,.5,1)!important}@media (prefers-reduced-motion:reduce){.lk-press{transform:none!important}}';
    document.head.appendChild(st);
    var cur = null;
    function up() {
      if (!cur) return;
      var el = cur;
      cur = null;
      el.classList.remove('lk-press');
      el.classList.add('lk-press-out');
      setTimeout(function () { el.classList.remove('lk-press-out'); }, 280);
    }
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest(PRESS);
      if (!b || b.disabled) return;
      cur = b;
      b.classList.add('lk-press');
    }, { passive: true });
    document.addEventListener('pointerup', up, { passive: true });
    document.addEventListener('pointercancel', up, { passive: true });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest(PRESS);
      if (b && !b.disabled && !b.classList.contains('lk-gc')) haptic('tap');
    }, true);
  })();

  // Le panier se réaffiche après chaque ajout : on repart de l'état précédent pour que le mouvement se voie.
  var animT = null;
  var animF = null;
  function animateBar(bar) {
    if (bar.getAttribute('data-lk-seen')) return;
    bar.setAttribute('data-lk-seen', '1');
    var tf = parseInt(bar.getAttribute('data-lk-total'), 10) || 0;
    var t = bar.hasAttribute('data-lk-tg') ? (parseInt(bar.getAttribute('data-lk-tg'), 10) || 0) : tf;
    var fill = bar.querySelector('[data-lk-fill]');
    var c = cfg();
    if (animT !== null && (animT !== t || animF !== tf) && c && fill) {
      var goal = fillPct(tf, t, c);
      fill.style.transition = 'none';
      fill.style.width = fillPct(animF === null ? tf : animF, animT, c) + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(function () { fill.style.width = goal + '%'; });
      var won = false;
      bar.querySelectorAll('.lk-pal__step[data-s]').forEach(function (n) {
        var s = parseInt(n.getAttribute('data-s'), 10);
        var a0 = s === c.fs ? animF : animT, a1 = s === c.fs ? tf : t;
        if (a0 !== null && a0 < s && a1 >= s) { n.classList.add('lk-pop'); won = true; }
      });
      if (won) haptic('win');
      var msg = bar.querySelector('[data-lk-msg]');
      if (msg) msg.classList.add('lk-in');
    }
    animT = t;
    animF = tf;
  }
  function watchBars() {
    var scan = function () { document.querySelectorAll('[data-lk-pal]').forEach(animateBar); };
    scan();
    ['cart-drawer', '.lk-cart-page-bar'].forEach(function (q) {
      var el = document.querySelector(q);
      if (el) new MutationObserver(scan).observe(el, { childList: true, subtree: true });
    });
  }

  // ----- Page de choix des 3 cadeaux -----
  // Le client choisit librement ; le panier ne change qu'à la validation (la remise exige les 3 cadeaux ensemble).
  var GP = { el: null, items: null, load: null, sel: [], open: false };

  function loadGifts(c) {
    if (GP.load) return GP.load;
    GP.load = fetch('/collections/' + c.gc + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        GP.items = (j.products || []).map(function (p) {
          var v = p.variants && p.variants[0];
          var src = p.images && p.images[0] && p.images[0].src;
          if (!v || !v.available) return null;
          return { v: v.id, n: p.title.split(' — ')[0].split(' – ')[0].split(' (')[0], p: Math.round(parseFloat(v.price) * 100), img: src ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=240' : '' };
        }).filter(Boolean);
        return GP.items;
      })
      .catch(function () { GP.load = null; GP.items = null; return null; });
    return GP.load;
  }
  function esc(x) { var d = document.createElement('div'); d.textContent = x; return d.innerHTML; }
  function slotIds(c) { return c.tiers.map(function (g) { return g.id; }); }
  function currentSel(c) {
    var out = [];
    slotIds(c).forEach(function (id) {
      var l = lastCart && giftLine(lastCart, id);
      var v = l ? l.variant_id : parseInt(store('lk_cad3_' + id), 10);
      if (v && out.indexOf(v) < 0) out.push(v);
    });
    return out;
  }
  function itemOf(v) { return (GP.items || []).filter(function (i) { return i.v === v; })[0]; }
  function paintPicker() {
    var c = cfg(), el = GP.el;
    if (!el || !c) return;
    var t = lastCart ? eligibleG(lastCart) : 0;
    var sel = GP.sel, n = sel.length;
    el.querySelector('[data-gp-sub]').textContent = t >= c.max ? 'Ils sont offerts. À toi de choisir.' : 'Offerts dès ' + money(c.max).replace(/,00/, '') + ' d’achat' + (c.hb ? ' hors bonnes affaires' : '') + '. Il te manque ' + money(c.max - t) + '.';
    el.querySelectorAll('[data-gp-v]').forEach(function (b) {
      var on = sel.indexOf(parseInt(b.getAttribute('data-gp-v'), 10)) >= 0;
      b.classList.toggle('is-on', on);
      b.classList.toggle('is-off', !on && n >= 3);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var val = 0, slots = '';
    for (var i = 0; i < 3; i++) {
      var it = sel[i] && itemOf(sel[i]);
      if (it) val += it.p;
      slots += it ? '<button type="button" class="lk-gp__s is-on" data-gp-rm="' + it.v + '" aria-label="Retirer ' + esc(it.n) + '"><img src="' + it.img + '" alt=""><i>×</i></button>' : '<span class="lk-gp__s">' + (i + 1) + '</span>';
    }
    el.querySelector('[data-gp-slots]').innerHTML = slots;
    el.querySelector('[data-gp-val]').textContent = n ? 'Valeur offerte ' + money(val) : '3 cadeaux à choisir';
    var go = el.querySelector('[data-gp-ok]');
    go.classList.toggle('lk-ready', n === 3);
    go.disabled = n < 3;
    go.textContent = n < 3 ? 'Choisis encore ' + (3 - n) : (t >= c.max ? 'Valider mes 3 cadeaux' : 'Garder mes 3 cadeaux');
  }
  function buildPicker(c) {
    if (GP.el) return GP.el;
    var el = document.createElement('div');
    el.className = 'lk-gp';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Choisis tes 3 cadeaux');
    el.innerHTML = '<div class="lk-gp__box"><header class="lk-gp__h"><div><h2>Choisis tes 3 cadeaux</h2><p data-gp-sub></p></div><button type="button" class="lk-gp__x" data-gp-close aria-label="Fermer">×</button></header><div class="lk-gp__g" data-gp-grid><p class="lk-gp__wait">Chargement…</p></div><p class="lk-gp__t" data-gp-toast role="status" hidden></p><footer class="lk-gp__f"><div class="lk-gp__sw"><div class="lk-gp__ss" data-gp-slots></div><span data-gp-val></span></div><button type="button" class="lk-gp__ok" data-gp-ok disabled>Choisis encore 3</button></footer></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      var x = e.target.closest('[data-gp-close]');
      if (x || e.target === el) { closePicker(true); return; }
      var rm = e.target.closest('[data-gp-rm]');
      if (rm) { GP.sel = GP.sel.filter(function (v) { return v !== parseInt(rm.getAttribute('data-gp-rm'), 10); }); paintPicker(); return; }
      var b = e.target.closest('[data-gp-v]');
      if (b) {
        var v = parseInt(b.getAttribute('data-gp-v'), 10), at = GP.sel.indexOf(v);
        if (at >= 0) { GP.sel.splice(at, 1); haptic('tap'); }
        else if (GP.sel.length < 3) { GP.sel.push(v); haptic(GP.sel.length === 3 ? 'win' : 'tap'); b.classList.remove('lk-chk'); void b.offsetWidth; b.classList.add('lk-chk'); }
        else { haptic('tap'); b.classList.remove('lk-no'); void b.offsetWidth; b.classList.add('lk-no'); toast('Tu as déjà 3 cadeaux. Touche-en un pour le retirer.'); return; }
        paintPicker();
        return;
      }
      if (e.target.closest('[data-gp-ok]')) validatePicker();
    });
    GP.el = el;
    return el;
  }
  var toastT = null;
  function toast(m) {
    var o = GP.el.querySelector('[data-gp-toast]');
    o.textContent = m; o.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { o.hidden = true; }, 2200);
  }
  function openPicker() {
    var c = cfg();
    if (!c || !c.gc || GP.open) return;
    var el = buildPicker(c);
    GP.open = true;
    GP.sel = currentSel(c);
    el.classList.add('is-open');
    el.classList.toggle('has-pbar', !!document.getElementById('PBarNextFrameWrapper')); // aperçu du thème : la barre Shopify couvre le bas
    document.documentElement.classList.add('lk-gp-lock');
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
    try { history.pushState({ lkGifts: 1 }, ''); } catch (err) {}
    paintPicker();
    loadGifts(c).then(function (items) {
      var grid = el.querySelector('[data-gp-grid]');
      if (!items) { grid.innerHTML = '<p class="lk-gp__wait">Impossible de charger les cadeaux. Réessaie dans un instant.</p>'; return; }
      GP.sel = GP.sel.filter(function (v) { return !!itemOf(v); });
      grid.innerHTML = items.map(function (i) {
        return '<button type="button" class="lk-gc" data-gp-v="' + i.v + '" aria-pressed="false"><span class="lk-gc__i"><img src="' + i.img + '" alt="" loading="lazy" width="120" height="120"></span><span class="lk-gc__n">' + esc(i.n) + '</span><span class="lk-gc__p"><s>' + money(i.p) + '</s> Offert</span><i class="lk-gc__c" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></i></button>';
      }).join('');
      paintPicker();
    });
    setTimeout(function () { var x = el.querySelector('[data-gp-close]'); if (x) x.focus(); }, 30);
  }
  function closePicker(fromUser) {
    if (!GP.open) return;
    GP.open = false;
    GP.el.classList.remove('is-open');
    document.documentElement.classList.remove('lk-gp-lock');
    var dr = document.querySelector('cart-drawer.active .drawer__inner, cart-drawer.active');
    if (dr && typeof window.trapFocus === 'function') window.trapFocus(dr);
    if (fromUser && history.state && history.state.lkGifts) { try { history.back(); } catch (err) {} }
  }
  function validatePicker() {
    var c = cfg();
    if (!c || GP.sel.length < 3) return;
    var picks = GP.sel.slice();
    var ids = slotIds(c);
    closePicker(true);
    var t = lastCart ? eligibleG(lastCart) : 0;
    if (t < c.max) { ids.forEach(function (id, n) { store('lk_cad3_' + id, String(picks[n])); }); return; }
    applyPicks(c, ids, picks);
  }
  function applyPicks(c, ids, picks) {
    if (busy) { setTimeout(function () { applyPicks(c, ids, picks); }, 200); return; }
    busy = true;
    getCart().then(function (cart) {
      var left = picks.slice(), free = [], up = {};
      ids.forEach(function (id) {
        var l = giftLine(cart, id);
        if (l && left.indexOf(l.variant_id) >= 0) { left.splice(left.indexOf(l.variant_id), 1); store('lk_cad3_' + id, String(l.variant_id)); }
        else { free.push(id); if (l) up[l.key] = 0; }
      });
      var adds = left.map(function (v, n) { store('lk_cad3_' + free[n], String(v)); seen[free[n]] = true; return { id: v, quantity: 1, properties: { _lk_cadeau: free[n] } }; });
      var first = Object.keys(up).length ? post('/cart/update.js', { updates: up }) : Promise.resolve();
      return first.then(function () { return adds.length ? post('/cart/add.js', { items: adds }) : null; });
    })
      .catch(function () {})
      .then(function () { refreshUI(); })
      .then(release, release);
  }
  window.addEventListener('popstate', function () { if (GP.open) closePicker(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && GP.open) { e.stopPropagation(); closePicker(true); } }, true);

  function togglePanel(tg, forceOpen) {
    var panel = document.getElementById(tg.getAttribute('aria-controls'));
    if (!panel) return;
    var open = forceOpen ? true : panel.hidden;
    panel.hidden = !open;
    tg.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      try { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) { panel.scrollIntoView(); }
    }
  }

  document.addEventListener('click', function (e) {
    var gop = e.target.closest && e.target.closest('[data-lk-gifts-open]');
    if (gop) {
      e.preventDefault();
      openPicker();
      return;
    }
    var tg = e.target.closest && e.target.closest('[data-lk-cadeau-toggle]');
    if (tg) {
      e.preventDefault();
      togglePanel(tg);
      return;
    }
    var voir = e.target.closest && e.target.closest('[data-lk-cadeau-voir]');
    if (voir) {
      e.preventDefault();
      var root = voir.closest('#CartDrawer') || document.getElementById('main-cart-items') || document;
      var first = root.querySelector('[data-lk-cadeau-toggle]');
      if (first) togglePanel(first, true);
      return;
    }
    var pk = e.target.closest && e.target.closest('[data-lk-cadeau-pick]');
    if (pk) {
      e.preventDefault();
      pick(pk.getAttribute('data-tier'), parseInt(pk.getAttribute('data-v'), 10), pk);
    }
  });

  // ----- lignes regroupées (découpage Shopify) : la quantité affichée = total de toutes les clés -----
  function mergedUpdate(keys, qty) {
    var up = {};
    keys.forEach(function (k, i) { if (k) up[k] = i === 0 ? qty : 0; });
    return post('/cart/update.js', { updates: up }).then(refreshUI).catch(refreshUI);
  }
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('input[data-lk-merge-keys]')) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    mergedUpdate(inp.getAttribute('data-lk-merge-keys').split(','), Math.max(0, parseInt(inp.value, 10) || 0));
  }, true);
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-remove-button[data-lk-merge-keys]');
    if (!rm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    mergedUpdate(rm.getAttribute('data-lk-merge-keys').split(','), 0);
  }, true);

  document.addEventListener('cart:refresh', function () { setTimeout(sync, 60); });
  watchBars();
  (function () {
    var c = cfg();
    if (!c || !c.gc) return;
    var go = function () { loadGifts(c); };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1500);
  })();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
